<template>
  <v-container class="centrar">

    <div v-if="!sesionIniciada">
      <div class="d-flex justify-center pa-5">
        <v-form
          v-model="Valido"
          class="elevation-4 pa-4 white"
          @submit.prevent="btnIniciarSesion"
          id="login"
        >
          <p class="text-h5">Ingresa tus credenciales para continuar.</p>

          <v-text-field
            label="Usuario"
            class=""
            clearable
            solo
            required
            v-model="usuario"
            :rules="[(v) => !!v || 'Ingresa tu usuario']"
          />

          {{/* CAMPO CONTRASEÑA */}}
          <v-text-field
            label="Contraseña"
            solo
            required
            v-model="password"
            :append-icon="mostrarPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="mostrarPassword ? 'text' : 'password'"
            :rules="[(v) => !!v || 'Ingresa tu contraseña']"
            @click:append="mostrarPassword = !mostrarPassword"
          />
          {{ /* FIN CAMPO CONTRASEÑA */ }}

          {{ /*   MENSAJE ERROR */ }}

          <v-alert v-if="error" class="red lighten-3 d-flex justify-center">
            <span class="text--white">{{mensajeError}}..</span>
          </v-alert>

          {{ /* FIN MENSAJE ERROR */ }}

          <div class="d-flex justify-center">
            <v-btn type="" color="primary" :disabled="!Valido" :loading="cargando">
              <span> Acceder </span></v-btn
            >
          </div>
        </v-form>
      </div>

      <div class="d-flex justify-center">
        <span></span>
        <!-- <a href="#" class="grey--text text--darken-4"> Recuperar contraseña</a> -->
      </div>
    </div>

    <div v-else class="d-flex justify-center">
      <v-card elevation="5">
        <v-card-title>
          <span class="ma-3">Sesion Activa</span>
        </v-card-title>
        <v-card-text>
          <span class="mx-1 font-weight-bold text--primary">Ya existe una sesion activa con usuario: 
           <u class="mx-2"> {{getUsuario}} </u> </span>
        </v-card-text>
        <v-card-actions class="mx-2 my-1">
          <v-btn text light class="primary" @click="regresar">
            <v-icon> mdi-arrow-left</v-icon>
            <span>Regresar</span>
          </v-btn>
        </v-card-actions>
      </v-card>

    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {

  data: () => ({
    usuario: "",
    password: "",
    mostrarPassword: false,
    Valido: true,
    result: null,
    cargando:false,
    mostrarMensaje: false,
    error: false, mensajeError:'',
    
  }),

  // async created() {
  //   // let respuesta = await axios.get("http://192.168.1.90:3300/")
  //   let respuesta = await axios.get("http://localhost:3000/login");
  //   this.result = respuesta.data;
  // },
  computed: {

    ...mapGetters(["sesionIniciada","getUsuario","getURLAPI"]),

  },

  methods: {
    
    btnIniciarSesion() {
      this.cargando = true;

      const credenciales = {
        USUARIO: this.usuario.toUpperCase(),
        PASS: this.password
      }

      axios.post ( `${this.getURLAPI}/Usuarios/login`, credenciales )
      .then( ( { data } ) => {
        if (data.STATUS == "ERROR"){
          this.error = true;
          this.mensajeError = data.MSG;
          this.cargando = false;
        }else{
          this.$store.dispatch("login", data);
          this.$router.push({ name: "Dashboard" });
          this.cargando = false;

        }
      })
      .catch( (err) => {
        console.log(err);
        this.error = true;
        this.mensajeError= 'Ocurrio un problema con el servidor.';
        this.cargando = false;
        })

      // this.$store.dispatch("login", {
      //     USUARIO: this.usuario.toUpperCase(),
      //     PASS: this.password,
      //   })
      //   .then(() => {
      //     this.$router.push({ name: "Dashboard" })
      //     })
      //   .catch(err => {
      //     console.log(err.message)
      //     this.error = true;
      //     this.mensajeError = 'Ocurrio un problema con el servidor.'
      //   })
    },

    regresar(){
      this.$router.push({name:"Dashboard"})
    }

  },
  created() {
    document.title = "Login | Bombas y Suministros del Norte"

  },


};

</script>

<style>
.centrar{
  margin-top: 10%!important;
}
form > div.v-input{
  /* background-color: grey!important; */
}
form#login > div.v-input > .v-input__control > .v-input__slot{
  background: #e4e4e4!important;
}
</style>
